// extracted by mini-css-extract-plugin
export var banner = "_i5-0";
export var closeButton = "_i5-2";
export var greenCheckmark = "_i5-3";
export var hereLink = "_i5-4";
export var titleIcon = "_i5-1";